import { render, staticRenderFns } from "./TableUserItem.vue?vue&type=template&id=132237bf&scoped=true"
import script from "./TableUserItem.vue?vue&type=script&lang=js"
export * from "./TableUserItem.vue?vue&type=script&lang=js"
import style0 from "./TableUserItem.vue?vue&type=style&index=0&id=132237bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132237bf",
  null
  
)

export default component.exports